import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import DependencyTaskLink from './DependencyTaskLink';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DependencyTasksTooltip = ({
  dependencyTasks,
  children,
  taskKey
}) => {
  const {
    trackTaskInteraction
  } = useTracker();
  const trackDependencyTaskClick = useCallback(dependencyTaskKey => trackTaskInteraction('click task action in dependency tooltip', dependencyTaskKey, {
    dependentTask: taskKey
  }), [taskKey, trackTaskInteraction]);
  if (!dependencyTasks || dependencyTasks.length === 0) {
    return children;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "dependency-tasks-tooltip",
    placement: "right",
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.checklist.completeDependencyTasks"
        })
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        children: dependencyTasks.map(dependencyTask => /*#__PURE__*/_jsx(DependencyTaskLink, {
          dependencyTask: dependencyTask,
          onClick: () => trackDependencyTaskClick(dependencyTask.key)
        }, dependencyTask.key))
      })]
    }),
    use: "longform",
    children: children
  });
};
export default DependencyTasksTooltip;